import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";

import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import AccountSetup from "./AccountSetup";
import Contactus from "./Contactus";
import CookiePolicy from "./CookiePolicy";
import Dashboardenterpriseone from "./Dashboardenterpriseone";
import Faq from "./Faq";
import Favourites from "./Favourites";
import Help from "./Help";
import ModernSlavery from "./ModernSlavery";
import MyReferralDetails from "./MyReferralDetails";
import Myreferrals from "./Myreferrals";
import OTPAuthentication from "./OTPAuthentication";
import PrivacyPolicy from "./PrivacyPolicy";
import PrivateRoute from "./PrivateRoute";
import Profileone from "./Profileone";
import { checkAuthStatus } from "./redux/slices/authThunks";
import { fetchMemberDetails } from "./redux/slices/MembersThunks";
import Referafriendone from "./Referafriendone";
import Referafriendtwo from "./Referafriendtwo";
import Referralsone from "./Referralsone";
import Referralstwo from "./Referralstwo";
import Rewardsone from "./Rewardsone";
import RootLayout from "./RootLayout";
import Signup from "./Signup";
import TermsAndConditions from "./TermsAndConditions";
import Vendornominate from "./Vendornominate";
import PWAInstallButton from "./PWAInstallButton";
import CelebrationConfetti from "./prtnr/ui/CelebrationConfetti";

const router = createBrowserRouter([
  // Auth routes only (with RootLayout)
  {
    element: <RootLayout />,
    children: [
      { path: "/signup", element: <Signup /> },
      { path: "/account-setup", element: <AccountSetup /> },
      { path: "/otp/:userId", element: <OTPAuthentication /> },
      { path: "/vendors", element: <Referralsone /> },
      { path: "/vendors/:slug", element: <Referralstwo /> },
    ],
  },
  {
    element: (
      <PrivateRoute>
        <Outlet />
      </PrivateRoute>
    ),
    children: [
      { path: "/favourites", element: <Favourites /> },
      { path: "/myreferrals", element: <Myreferrals /> },
      { path: "/myreferrals/:id", element: <MyReferralDetails /> },

      { path: "/faq", element: <Faq /> },
      { path: "/contact-us", element: <Contactus /> },
      { path: "/privacy-policy", element: <PrivacyPolicy /> },
      { path: "/modern-slavery", element: <ModernSlavery /> },
      { path: "/cookie-policy", element: <CookiePolicy /> },
      { path: "/terms-and-conditions", element: <TermsAndConditions /> },
      { path: "/vendornominate", element: <Vendornominate /> },
      { path: "/rewardsone", element: <Rewardsone /> },
      { path: "/profileone", element: <Profileone /> },
      { path: "/referafriendtwo", element: <Referafriendtwo /> },
      { path: "/referafriendone", element: <Referafriendone /> },
      { path: "/referralstwo", element: <Referralstwo /> },
      { path: "/help", element: <Help /> },

      {
        path: "/dashboardenterpriseone",
        element: <Dashboardenterpriseone />,
      },
      {
        index: true,
        element: <Dashboardenterpriseone />,
      },
    ],
  },
]);

const App = () => {
  const dispatch = useDispatch();
 
  useEffect(() => {
    const member = JSON.parse(localStorage.getItem("member"));
    if (member?._id) {
      dispatch(fetchMemberDetails(member._id));
    }
  }, [dispatch]);

  useEffect(() => {
    dispatch(checkAuthStatus()); // initial check

    const interval = setInterval(() => {
      dispatch(checkAuthStatus());
    }, 25 * 60 * 1000); // every 25 minutes

    return () => clearInterval(interval); // cleanup
  }, [dispatch]);

  return (
    <div>
      <RouterProvider router={router} />
      <ToastContainer position="top-right" autoClose={3000} />
      <CelebrationConfetti/>
      <PWAInstallButton />
    </div>
  );
};
export default App;
